import { useT } from '../../hooks/useTranslation'

// Экран «Тех. работы»: показывается ВСЕМ пользователям, когда админ включил
// maintenance в конфиге. Полноэкранный, без навигации — разделы приложения
// недоступны во время работ.
export default function MaintenanceScreen() {
  const t = useT()
  return (
    <div
      style={{
        height: 'var(--tg-app-height, 100dvh)',
        background: '#050505',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '0 36px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 52, lineHeight: 1 }}>🛠️</div>
      <div style={{ fontSize: 19, fontWeight: 700, color: '#fff' }}>{t.maintenanceTitle}</div>
      <div style={{ fontSize: 14, color: '#8E8E93', lineHeight: 1.6 }}>{t.maintenanceText}</div>
    </div>
  )
}
